import { Routes } from '@angular/router';
import { MarketComponent } from '../market/market.component';

export const TELEMARKETING_ROUTES: Routes = [
  {
    path: ':segmentoId',
    component: MarketComponent,
    data: {
      title: 'Telemarketing',
      icon: 'fa-solid fa-headset',
      breadcrumb: 'Telemarketing'
    }
  }
];
